<template>
  <div v-if="ponies && ponies.length">
    <InfoSectionHeading>Other Ponies in Group</InfoSectionHeading>
    <div>
      <div class="list-item-grid">
        <transition-group tag="div" name="fade">
          <PonyCard
            :key="item.id"
            v-for="item in ponies"
            :item="item"
            :user="user"
            :authenticated="authenticated"
          />
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import { showPrompt } from '../../utils/helpers'
import PonyCard from '../PonyCard/PonyCard';
import InfoSectionHeading from '../InfoSectionHeading/InfoSectionHeading';

export default {
  name: 'GroupPonies',
  components: {
    PonyCard,
    InfoSectionHeading
  },
  props: {
    ponies: {
      type: Array,
      default: () => ([]),
    },
    user: {
      type: Object,
      default: () => ({}),
    },
    authenticated: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    removeItem(payload) {
      showPrompt();

      this.$store.dispatch('pony/REMOVE', {
        id: payload.id
      });
    },
    url(id) {
      return `/pony/${id}`
    }
  }
};
</script>

<style scoped lang="scss">
.list-item-grid > div {
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  justify-content: space-between;
}
</style>
